import { createAction, createReducer } from "@reduxjs/toolkit";
import { useReducerManager } from "../redux";

const ALLOWED_TYPES = ["string", "number", "boolean", "undefined"];

const initialState = {
	value: undefined,
};

const setValue = createAction("setValue");

const reduceValue = (state, { payload }) => {
	return {
		...state,
		value: payload,
	};
};

const getValue = (state) => {
	return state.value;
};

const reducer = createReducer(initialState, {
	[setValue]: reduceValue,
});

export default (
	id,
	options = {
		initialState: "",
		persist: false,
	},
) => {
	const [select, dispatch] = useReducerManager({
		id,
		reducer,
		initialState: {
			value: options?.initialState,
		},
		persist: options?.persist,
	});
	const setState = (value) => {
		const valueType = typeof value;
		if (ALLOWED_TYPES.indexOf(valueType) === -1) {
			console.error(
				`Invalid type passed to useSimpleReducer. Type passed: ${valueType}`,
			);
			return false;
		}
		dispatch(setValue(value));
	};
	return [select(getValue), setState];
};
